import { TimePicker as TimePickerAD } from 'antd';
import type { TimePickerProps } from 'antd';
import cn from 'classnames';
import { useGetDatePickerFormat, useIsTwelveHourFormat } from '../date-picker';
import styles from './time-picker.module.css';

export type TimePickerProperties = {
  fullWidth?: boolean;
} & TimePickerProps;

const TimePicker = ({ className, fullWidth, ...props }: TimePickerProperties) => {
  const getDatePickerFormat = useGetDatePickerFormat();
  const isTwelveHourFormat = useIsTwelveHourFormat();

  return (
    <TimePickerAD
      className={cn(className, { [styles['full-width'] ?? '']: fullWidth })}
      format={getDatePickerFormat('defaultTimeFormat')}
      showSecond={false}
      size="large"
      use12Hours={isTwelveHourFormat}
      {...props}
    />
  );
};

export default TimePicker;
